module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephen Amidon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("STEPHEN AMIDON")]), _vm._v("'s previous books include "), _c('I', [_vm._v("Human Capital")]), _vm._v(", "), _c('I', [_vm._v("The New City")]), _vm._v(", and "), _c('I', [_vm._v("Subdivision")]), _vm._v(". He lives in western Massachusetts.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bVVcNt/tc-custom/9781429930086.jpg?1722339024827",
      "alt": "This image is the cover for the book Security"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Security\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("There isn't much crime in Stoneleigh, Massachusetts. It's a college town, a mountain getaway for the quietly rich,"), _c('br'), _vm._v("where the average burglar alarm is set off by foraging wildlife. So when Edward Inman, the owner of Stoneleigh Sentinel, gets a latenight false alarm from the home of Doyle Cutler, one of his wealthiest clients, Edward thinks nothing of it—not until a local student, Mary Steckl, claims that she was sexually assaulted at Cutler's house."), _c('br'), _c('br'), _vm._v("Edward soon finds himself drawn to Mary's story, even though the rest of the town doubts her, including his wife, a rising politician who has made security the platform of her mayoral campaign. While homework from a creative writing class is leaked as evidence of a dark secret between Mary and her father, Edward's investigations lead him to his old girlfriend, Kathryn Williams, whose teenage son may hold the key to the truth about that night."), _c('br'), _c('br'), _vm._v("From the author of "), _c('i', [_vm._v("Human Capital")]), _vm._v(", "), _c('i', [_vm._v("Security")]), _vm._v(" is a timely, wry, and riveting story of adults and children, secret lives and civic"), _c('br'), _vm._v("culture, suspicion and sexual hysteria. It confirms Stephen Amidon as a master of the art and one of the foremost chroniclers of American life today.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Farrar, Straus and Giroux\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0